/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
/* Services */

/**
 * Renders the Features component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Features component
 */

const Features = ({ sectionContent, region, language }) => {
  const featureData = sectionContent.body.find(
    el => el.sectionId == 'Section-1'
  );
  return (
    <>
      <Box
        display={{ base: 'block', sm: 'flex' }}
        justifyContent="center"
        margin={{ base: '0 auto', lg: '-200px auto 0' }}
        maxW="1024px"
        position="relative"
      >
        {featureData?.sectionContent[0]?.simpleCards?.map((el, i) => {
          return (
            <Box
              textAlign="center"
              w={{
                base: 'auto',
                sm: 'calc((100% - 60px) / 4)',
                lg: 'calc((100% - 90px) / 4)',
              }}
              marginRight={{ base: '0', lg: '30px' }}
            >
              <LazyLoadImageComponent
                src={el.rectangularImage.url}
                title={el.rectangularImage.title}
                alt={el.rectangularImage.alt}
              />
              <Text
                fontSize={{ base: '18px', lg: '18px' }}
                color="#ffffff"
                p={{ base: '0 27%', sm: '0' }}
                fontFamily="FedraSansStd-A-medium"
                className="feature_text"
              >
                {el.title == '' ? (
                  <>
                    {StructuredTextContent(featureData.sectionContent[1]?.body)}
                  </>
                ) : (
                  <>{el.title}</>
                )}
              </Text>
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default Features;
